import React from "react";
import ButtonGroup from "./ButtonGroup";
export default function CreateAccountAndLoginButtonGroup() {
	return (
		<ButtonGroup
			button1Variant="dark"
			btn1={{
				text: "Create Free Account",
				url: `${process.env.APP_URL}/signup`,
			}}
			button2Variant="light"
			btn2={{
				text: "Login",
				url: `${process.env.APP_URL}/`,
			}}
			paddingTop="3"
		/>
	);
}
